import { UniversalNavLinkType } from '../../../constants/links';

import type { SidebarV3 } from './types';

export const ACCOUNT_USAGE_LINK: UniversalNavLinkType = {
  href: '/app/settings/billing',
  icon: { selected: 'miscWallet', unselected: 'miscWallet' },
  text: 'Usage',
};

export const FALLBACK_SIDEBAR_RESPONSE: SidebarV3.APIResponse = {
  itemGroups: [
    [
      {
        href: '/app/home',
        icon: 'navHome',
        iconFilled: 'navHomeFill',
        text: 'Home',
      },
    ],
    [
      {
        href: '/app/zaps',
        icon: 'miscBoltAltFill',
        iconFilled: 'miscBoltAltFill',
        text: 'Zaps',
      },
      {
        href: `https://tables.zapier.com/app/tables?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier`,
        icon: 'navTables',
        iconFilled: 'navTables',
        text: 'Tables',
      },
      {
        href: `https://interfaces.zapier.com/interfaces?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier/`,
        icon: 'navInterfaces',
        iconFilled: 'navInterfaces',
        text: 'Interfaces',
      },
      {
        href: '/app/chatbots',
        text: 'Chatbots',
        icon: 'navAIChatbot',
        iconFilled: 'navAIChatbot',
        tag: 'Beta',
      },
      {
        href: '/app/canvas',
        text: 'Canvas',
        icon: 'navCanvas',
        iconFilled: 'navCanvas',
        tag: 'Beta',
      },
    ],
    [
      {
        href: '/app/connections',
        icon: 'navApps',
        iconFilled: 'navAppsFill',
        text: 'Apps',
      },
      {
        href: '/app/history',
        icon: 'miscClock',
        iconFilled: 'miscClockFill',
        text: 'Zap History',
      },
    ],
  ],
  moreLinks: {
    text: 'More',
    icon: 'navMoreHoriz',
    moreLinksItems: [
      {
        description: 'Build custom AI assistants.',
        href: 'https://central.zapier.com/?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier',
        icon: 'navCentral',
        iconFilled: 'navCentral',
        tag: 'Beta',
        target: '_blank',
        text: 'Central',
      },
      {
        description: 'Build automations with code.',
        href: 'https://functions.zapier.com/?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier',
        icon: 'navFunctions',
        iconFilled: 'navFunctions',
        tag: 'Alpha',
        text: 'Functions',
      },
      {
        description: 'Integrate your app into Zapier.',
        href: '/platform',
        icon: 'actionBuild',
        iconFilled: 'actionBuild',
        text: 'Developer platform',
      },
    ],
  },
};
